/* eslint-disable jsx-a11y/alt-text */
import React, { useState, useEffect } from "react";
import Modal from 'react-modal';
import { mask4 } from "../assets";
import Utility from "../utility/utility"

const ChanceCardCommon = (props) => {
  const TOTAL_DURATION = 10;
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [seconds, setSeconds] = useState(10);
  const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      transform: 'translate(0%, -50%)',

    }
  };

  useEffect(() => {

    const timer = () => setTimeout(async () => {
      const obj = await Utility.checkAssetType(props.questionObject?.Column7, props.assets)
      if (obj.assetAvailabity) {
        props.checkCardOverlayCallback(obj.obj)
      } else {
        props.keepOpenCallback(props.assets)
      }
    }, TOTAL_DURATION*1000);

    const timerId = timer();
    return () => {
      clearTimeout(timerId);
    };
  }, [])

  useEffect(() => {
    const timer = () => setTimeout(async () => {
      if (seconds >= 0)
        setSeconds(seconds => seconds - 1)
    }, 1000)
    const timerId = timer();
    return () => {
      clearTimeout(timerId);
    };
  }, [seconds])

  function afterOpenModal() {
    // references are now sync'd and can be accessed.
    //  subtitle.style.color = '#f00';
  }

  function closeModal() {
    setIsOpen(false);
  }

  return (
    <div>
      <Modal
        isOpen={true}
        onAfterOpen={afterOpenModal}
        onRequestClose={closeModal}
        ariaHideApp={false}
        style={customStyles}
        transparent={true}
      >
        <div  >
          <div >
            <div >

              <div className="modal-header hide">
                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                  <span className="close-btn" aria-hidden="true">
                    &times;
                  </span>
                </button>
              </div>

              <div >
                <div className="backcardlay">
                  <div className="container overlay-1">
                    <div className="position-relative d-flex flex-column justify-content-center align-items-center">

                      <div className="card overlay-card-1 ">
                        <header className="overlay-header d-flex flex-column align-items-start mb-2">
                          {props.tag && (
                            <span className="badge bg-light text-dark fw-bold me-2 py-1 px-2 position-relative mb-1" style={{ fontSize: '12px', left: '10px' }}>
                                {props.tag}
                            </span>
                          )}  
                          <h5 className="line-height memphis-mediums">
                            {props.questionObject?.Column3}
                          </h5>
                        </header>
                        <div className="col-md-12">

                          <div className="text-center chance-card-timer">
                            <span className="timer">:{seconds}</span>
                          </div>
                          <label className="container w-checkox memphis-medium color-mistake-pay mt-5 text-center">

                            <span className="m-auto Pacifico-Regulars">
                              {" "}
                              <img src={mask4} className="width-ovwelay-image" />{" "}
                              {Utility.printTextwithColor(props?.questionObject?.Column7)}
                            </span>
                          </label>
                        </div>
                        <div className="col-md-12 text-right mt-4">
                          <h6 className="health-overlay-color font-economy memphis-medium">&copy;<span className="ml-1">Health Economy 2019</span></h6>
                        </div>
                      </div>
                      {props?.v1 && <div className="mt-4">
                        <div className="card-overlay-2 bg-overlay">
                          <div className="text-center">
                            <button id="overlay-keepopen-button" onClick={(e) => props.keepOpenCallback(props.assets)} type="text" className="overlay-button">
                              Next
                            </button>
                          </div>
                        </div>
                      </div>}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default ChanceCardCommon;
